// extracted by mini-css-extract-plugin
module.exports = {"label":"BvvO","content":"hmVu","last":"_4O9Z"};